import { NgModule } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig, JwtHelper, tokenNotExpired } from 'angular2-jwt';

declare var jQuery: any;

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
    let token: string = sessionStorage.getItem("Token");
    let auth = new AuthConfig({
        tokenName: "Token",
        headerPrefix: "Token",
        noJwtError: true,
        noTokenScheme: true,
        tokenGetter: (()=>token),
        globalHeaders: [{'Content-Type':'application/json'}]
    });
    let algo = new AuthHttp(auth, http, options); 
    return algo;
}

@NgModule({
    providers: [
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        }
    ]
})
export class AuthModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/auth.module.ts